import React, { Suspense, lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import RegisterPage from '../website/pages/Register';
import ActivateMailMsgPage from '../website/pages/ActivateMailMsg';
import ActivateMailPage from '../website/pages/ActivateMail';
import LoginPage from '../website/pages/Login';
import CreateWorkspacePage from '../website/pages/CreateWorkspace';
import InvitationPage from '../website/pages/Invitation';
import Layout from '../components/layout/Layout';
import { checkAuthLoader } from '../util/auth';
import { action as logoutAction } from '../logout/Logout';
import { Card, Col, Row } from 'react-bootstrap';
import Home from '../website/pages/home/Home';

const SettingsLayout = lazy(() => import('../modules/settings/SettingsLayout'));
const Team = lazy(() => import('../modules/settings/Team'));
const Mailboxes = lazy(() => import('../modules/settings/Mailboxes'));

const ListsLayout = lazy(() => import('../modules/lists/ListsLayout'));
const Lists = lazy(() => import('../modules/lists/Lists'));
const List = lazy(() => import('../modules/lists/list/List'));

const Mailbox = lazy(() => import('../modules/mailbox/Mailbox'));
const MailsList = lazy(() => import('../modules/mailbox/MailsList'));

const FormsLayout = lazy(() => import('../modules/forms/FormsLayout'));
const FormsTemplates = lazy(() => import('../modules/forms/Templates'));
const Forms = lazy(() => import('../modules/forms/Forms'));
const FormsBuilder = lazy(() => import('../modules/forms/builder/Builder'));
const Form2Sign = lazy(() => import('../modules/forms/Form2Sign'));

// import ResetPasswordPage from '../website/pages/ResetPassword';
// import NewPasswordPage from '../website/pages/NewPassword';

// import SysSettingsLayout from '../modules/sysSettings/SysSettingsLayout';
// import SysSettings from '../modules/sysSettings/SysSettings';
// import SysSettingsDepartments from '../modules/sysSettings/SysSettingsDepartments';
// import SysSettingsRoles from '../modules/sysSettings/SysSettingsRoles';
// import SysSettingsUsers from '../modules/sysSettings/SysSettingsUsers';
// import SysSettingsModules from '../modules/sysSettings/SysSettingsModules';
// import Dashboard from '../modules/dashboard/Dashboard';

// const FilesManagerLayout = lazy(() => import('../modules/filesManager/FilesManagerLayout'));
// const FilesManagerHome = lazy(() => import('../modules/filesManager/FilesManagerHome'));
// const FilesManagerPublic = lazy(() => import('../modules/filesManager/FilesManagerPublic'));
// const FilesManagerStarred = lazy(() => import('../modules/filesManager/FilesManagerStarred'));
// const IframePage = lazy(() => import('../modules/iframe/IframePage'));

// const AutomationLayout = lazy(() => import('../modules/automation/AutomationLayout'));
// const Automation = lazy(() => import('../modules/automation/Automation'));
// const AutomationsList = lazy(() => import('../modules/automation/AutomationsList'));

const router = createBrowserRouter([
    {
        path: '/',
        // element: <Home />,
        element: <LoginPage />,
        errorElement: <h1>Error Page</h1>,
    }, {
        path: '/login',
        element: <LoginPage />,
        errorElement: <h1>Error Page</h1>,
    // }, {
    //     path: '/register',
    //     element: <RegisterPage />,
    //     errorElement: <h1>Error Page</h1>,
    // }, {
    //     path: '/activate-mail-msg',
    //     element: <ActivateMailMsgPage />,
    //     errorElement: <h1>Error Page</h1>,
    // }, {
    //     path: '/activate-mail/:token',
    //     element: <ActivateMailPage />,
    //     errorElement: <h1>Error Page</h1>,
    // }, {
    //     path: '/create-workspace/:token',
    //     element: <CreateWorkspacePage />,
    //     errorElement: <h1>Error Page</h1>,
        // }, {
        //     path: '/reset-password',
        //     element: <ResetPasswordPage />,
        //     errorElement: <h1>Error Page</h1>,
        // }, {
        //     path: '/new-password/:resetPasswordToken',
        //     element: <NewPasswordPage />,
        //     errorElement: <h1>Error Page</h1>,
    // }, {
    //     path: '/invitation/:token',
    //     element: <InvitationPage />,
    //     errorElement: <h1>Error Page</h1>,
    // }, {
    //     path: '/invitations',
    //     element: <div>invitations page</div>,
    //     errorElement: <h1>Error Page</h1>,
    //     id: 'invitations',
    //     loader: checkAuthLoader,
    // }, {
    //     path: '/f2s/:token',
    //     element: <Suspense fallback={<div>Loading...</div>}><Form2Sign /></Suspense>,
    //     errorElement: <h1>Error Page</h1>,
    }, {
        path: '/sys',
        element: <Layout />,
        errorElement: <h1>Error Page</h1>,
        id: 'sys',
        loader: checkAuthLoader,
        children: [
            { index: true, element: <iframe src="https://omniai.flexito.ai" style={{ width: '100%', height: 'var(--sidebar-height)' }} /> },

            // Settings
            // {
            //     path: 'settings',
            //     element: <Suspense fallback={<div>Loading...</div>}><SettingsLayout /></Suspense>,
            //     errorElement: <div>Error in Settings Module</div>,
            //     children: [
            //         {
            //             index: true,
            //             element: <div>Account</div>
            //             // element: <Suspense fallback={<div>Loading...</div>}><FilesManagerHome /></Suspense>
            //         }, {
            //             path: 'security',
            //             element: <div>Security</div>
            //             //     element: <Suspense fallback={<div>Loading...</div>}><FilesManagerPublic /></Suspense>
            //         }, {
            //             path: 'plan-billing',
            //             element: <div>Plan & Billing</div>
            //             //     element: <Suspense fallback={<div>Loading...</div>}><FilesManagerStarred /></Suspense>,
            //         }, {
            //             path: 'notifications',
            //             element: <div>Notifications</div>
            //             //     element: <Suspense fallback={<div>Loading...</div>}><SysSettingsRoles /></Suspense>,
            //         }, {
            //             path: 'team',
            //             element: <Suspense fallback={<div>Loading...</div>}><Team /></Suspense>
            //         }, {
            //             path: 'mailboxes',
            //             element: <Suspense fallback={<div>Loading...</div>}><Mailboxes /></Suspense>
            //             //     element: <Suspense fallback={<div>Loading...</div>}><SysSettingsUsers /></Suspense>
            //         }, {
            //             path: 'drive',
            //             element: <div>Drive</div>
            //             //     element: <Suspense fallback={<div>Loading...</div>}><SysSettingsUsers /></Suspense>
            //         }
            //     ]
            // },

            // Lists
            {
                path: 'lists',
                element: <Suspense fallback={<div>Loading...</div>}><ListsLayout /></Suspense>,
                errorElement: <div>Error in Lists Module</div>,
                children: [
                    {
                        index: true,
                        element: <Suspense fallback={<div>Loading...</div>}><Lists /></Suspense>
                    }, {
                        path: ':listId/:viewId',
                        element: <Suspense fallback={<div>Loading...</div>}><List /></Suspense>
                    }
                ]
            },

            // Mailbox
            // {
            //     path: 'mailbox',
            //     errorElement: <div>Error in Mailbox Module</div>,
            //     children: [
            //         {
            //             index: true,
            //             element: <Suspense fallback={<div>Loading...</div>}><Mailbox /></Suspense>
            //         }, {
            //             path: ':mailboxId/inbox',
            //             element: <Suspense fallback={<div>Loading...</div>}><MailsList folder="inbox" /></Suspense>
            //         }, {
            //             path: ':mailboxId/sent',
            //             element: <Suspense fallback={<div>Loading...</div>}><MailsList folder="sent" /></Suspense>
            //         }, {
            //             path: ':mailboxId/spam',
            //             element: <Suspense fallback={<div>Loading...</div>}><MailsList folder="spam" /></Suspense>
            //         }, {
            //             path: ':mailboxId/trash',
            //             element: <Suspense fallback={<div>Loading...</div>}><MailsList folder="trash" /></Suspense>
            //         }, {
            //             path: ':mailboxId/archive',
            //             element: <Suspense fallback={<div>Loading...</div>}><MailsList folder="archive" /></Suspense>
            //         }, {
            //             path: ':mailboxId/starred',
            //             element: <Suspense fallback={<div>Loading...</div>}><MailsList folder="starred" /></Suspense>
            //         }, {
            //             path: ':mailboxId/important',
            //             element: <Suspense fallback={<div>Loading...</div>}><MailsList folder="important" /></Suspense>
            //         }, {
            //             path: ':mailboxId/tags',
            //             element: <Suspense fallback={<div>Loading...</div>}><MailsList folder="tags" /></Suspense>
            //         }
            //     ]
            // },

            // Forms
            // {
            //     path: 'forms',
            //     element: <Suspense fallback={<div>Loading...</div>}><FormsLayout /></Suspense>,
            //     errorElement: <div>Error in Forms Module</div>,
            //     children: [
            //         {
            //             index: true,
            //             element: (
            //                 <div style={{ padding: '15px', height: 'calc(var(--forms-sidebar-height) - 62px)', overflow: 'auto' }}>
            //                     <Row>
            //                         <Col lg={4} md={6} sm={12}>
            //                             <Card
            //                                 // bg="light"
            //                                 // text="dark"
            //                                 style={{ borderLeft: '8px solid #009688d9' }}
            //                                 className="mb-2"
            //                             >
            //                                 <Card.Body>
            //                                     <Card.Text style={{ textAlign: 'center', fontSize: '40px', marginBottom: '5px' }}>
            //                                         5
            //                                     </Card.Text>
            //                                     <Card.Title className="" style={{ textAlign: 'center' }}>
            //                                         Templates
            //                                     </Card.Title>
            //                                 </Card.Body>
            //                             </Card>
            //                         </Col>
            //                         <Col lg={4} md={6} sm={12}>
            //                             <Card
            //                                 // bg="light"
            //                                 // text="dark"
            //                                 style={{ borderLeft: '8px solid #009688d9' }}
            //                                 className="mb-2"
            //                             >
            //                                 <Card.Body>
            //                                     <Card.Text style={{ textAlign: 'center', fontSize: '40px', marginBottom: '5px' }}>
            //                                         87
            //                                     </Card.Text>
            //                                     <Card.Title className="" style={{ textAlign: 'center' }}>
            //                                         Total forms
            //                                     </Card.Title>
            //                                 </Card.Body>
            //                             </Card>
            //                         </Col>
            //                         <Col lg={4} md={6} sm={12}>
            //                             <Card
            //                                 // bg="light"
            //                                 // text="dark"
            //                                 style={{ borderLeft: '8px solid #009688d9' }}
            //                                 className="mb-2"
            //                             >
            //                                 <Card.Body>
            //                                     <Card.Text style={{ textAlign: 'center', fontSize: '40px', marginBottom: '5px' }}>
            //                                         13
            //                                     </Card.Text>
            //                                     <Card.Title className="" style={{ textAlign: 'center' }}>
            //                                         Forms waiting signature
            //                                     </Card.Title>
            //                                 </Card.Body>
            //                             </Card>
            //                         </Col>
            //                         <Col lg={4} md={6} sm={12}>
            //                             <Card
            //                                 // bg="light"
            //                                 // text="dark"
            //                                 style={{ borderLeft: '8px solid #009688d9' }}
            //                                 className="mb-2"
            //                             >
            //                                 <Card.Body>
            //                                     <Card.Text style={{ textAlign: 'center', fontSize: '40px', marginBottom: '5px' }}>
            //                                         63
            //                                     </Card.Text>
            //                                     <Card.Title className="" style={{ textAlign: 'center' }}>
            //                                         Signed forms
            //                                     </Card.Title>
            //                                 </Card.Body>
            //                             </Card>
            //                         </Col>
            //                         <Col lg={4} md={6} sm={12}>
            //                             <Card
            //                                 // bg="light"
            //                                 // text="dark"
            //                                 style={{ borderLeft: '8px solid #009688d9' }}
            //                                 className="mb-2"
            //                             >
            //                                 <Card.Body>
            //                                     <Card.Text style={{ textAlign: 'center', fontSize: '40px', marginBottom: '5px' }}>
            //                                         11
            //                                     </Card.Text>
            //                                     <Card.Title className="" style={{ textAlign: 'center' }}>
            //                                         Forms without signature
            //                                     </Card.Title>
            //                                 </Card.Body>
            //                             </Card>
            //                         </Col>
            //                     </Row>
            //                 </div>
            //             )
            //         }, {
            //             path: 'templates',
            //             element: <Suspense fallback={<div>Loading...</div>}><FormsTemplates /></Suspense>
            //         }, {
            //             path: 'forms',
            //             element: <Suspense fallback={<div>Loading...</div>}><Forms /></Suspense>
            //             //     element: <Suspense fallback={<div>Loading...</div>}><FilesManagerPublic /></Suspense>
            //         }, {
            //             path: 'ffs',
            //             element: <div>Forms for signature</div>
            //             //     element: <Suspense fallback={<div>Loading...</div>}><FilesManagerPublic /></Suspense>
            //         }
            //     ]
            // },

            // Builder
            // {
            //     path: 'builder/:formId',
            //     element: <Suspense fallback={<div>Loading...</div>}><FormsBuilder /></Suspense>,
            //     errorElement: <div>Error in Forms Module</div>
            // },

            //         {
            //             path: 'external',
            //             element: <Suspense fallback={<div>Loading...</div>}><IframePage /></Suspense>,
            //             errorElement: <div>Error in DigitalSignatureModule Module</div>,
            //         },

            //         {
            //             path: 'filesManager',
            //             element: <Suspense fallback={<div>Loading...</div>}><FilesManagerLayout /></Suspense>,
            //             children: [
            //                 {
            //                     index: true,
            //                     element: <Suspense fallback={<div>Loading...</div>}><FilesManagerHome /></Suspense>
            //                 }, {
            //                     path: 'public',
            //                     element: <Suspense fallback={<div>Loading...</div>}><FilesManagerPublic /></Suspense>
            //                 }, {
            //                     path: 'starred',
            //                     element: <Suspense fallback={<div>Loading...</div>}><FilesManagerStarred /></Suspense>,
            //                 }
            //             ]
            //         },

            //         {
            //             path: 'sysSettings',
            //             element: <Suspense fallback={<div>Loading...</div>}><SysSettingsLayout /></Suspense>,
            //             children: [
            //                 {
            //                     index: true,
            //                     element: <Suspense fallback={<div>Loading...</div>}><SysSettings /></Suspense>
            //                 }, {
            //                     path: 'departments',
            //                     element: <Suspense fallback={<div>Loading...</div>}><SysSettingsDepartments /></Suspense>,
            //                 }, {
            //                     path: 'roles',
            //                     element: <Suspense fallback={<div>Loading...</div>}><SysSettingsRoles /></Suspense>,
            //                 }, {
            //                     path: 'users',
            //                     element: <Suspense fallback={<div>Loading...</div>}><SysSettingsUsers /></Suspense>
            //                 }, {
            //                     path: 'modules',
            //                     element: <Suspense fallback={<div>Loading...</div>}><SysSettingsModules /></Suspense>
            //                 }, {
            //                     path: 'invoices',
            //                     element: <Suspense fallback={<div>Loading...</div>}><h1>Invoices List</h1></Suspense>
            //                 }
            //             ]
            //         },

            { path: 'logout', action: logoutAction },
        ]
    }
]);

export default router;